/**
 * Checks whether the given `value` is a `Instance`.
 * @param  {Object|Instance|null}  value
 * @returns {boolean}
 */
function isInstanceReduxUtil (value) {
  return (
    value &&
    typeof value.className !== 'undefined' &&
    typeof value.status !== 'undefined' &&
    typeof value.validation !== 'undefined'
  )
}

export default isInstanceReduxUtil
